import { Injectable } from '@angular/core';
import { CategoryPathInterface } from '../../models/category-path.model';

@Injectable({
  providedIn: 'root',
})
export class ThirdNavbarService {
  reorderSystems(systems: CategoryPathInterface[]): CategoryPathInterface[] {
    systems = systems.sort((a, b) => a.name.localeCompare(b.name));
    let index = 1;
    const systemsOrdered = systems.reduce((carry, system) => {
      const firstLetter = system.name.charAt(0);
      const foundElement = carry.find((element) => element.name === firstLetter);
      if (foundElement) {
        carry = carry.map((element) => {
          if (element.name === firstLetter) {
            element.children.push(system);
          }

          return element;
        });
      } else {
        carry.push({
          name: firstLetter,
          originalName: firstLetter,
          id: index++,
          children: [system],
          slug: firstLetter,
        });
      }

      return carry;
    }, []);

    return systemsOrdered.sort((a, b) => {
      return a.name.localeCompare(b.name);
    });
  }

  reorderCategories(categories: CategoryPathInterface[], smallScreen = false): CategoryPathInterface[] {
    const sortedCategories = [];

    const knownLargeScreenSlugs = [
      'desking',
      'executive-furniture',
      'chairs',
      'cable-management',
      'reception-furniture',
      'meeting',
      'screens-acoustic',
      'lounge-soft-furniture',
      'accessories',
      'storage',
      'marketing-materials',
    ];

    const knownSmallScreenSlugs = [
      'desking',
      'reception-furniture',
      'lounge-soft-furniture',
      'screens-acoustic',
      'meeting',
      'cable-management',
      'storage',
      'chairs',
      'accessories',
      'executive-furniture',
      'marketing-materials',
    ];

    const knownSlugs = smallScreen ? knownSmallScreenSlugs : knownLargeScreenSlugs;

    knownSlugs.forEach((slug) => {
      sortedCategories.push(categories.find((el) => el.slug === slug));
    });

    // add all other elements if there are any
    sortedCategories.push(...categories.filter((el) => !knownSlugs.includes(el.slug)));

    return sortedCategories;
  }
}
